
import { Vue, Prop, Component, Watch } from "vue-property-decorator";

import InputRangeFilter from "@/components/filters/InputRangeFilterNew.vue";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
import FiltersContainer from "@/components/filters/filters-container.vue";
import UiButton from "@/components/button/ui-button.vue";
import TitlesMultiselect from "@/components/autocompleteMultiselects/TitlesMultiselectNew.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
import ProjectsMultiselect from "@/components/autocompleteMultiselects/ProjectsMultiselectV2.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import ProfileAvailabilitySelect from "@/components/autocompleteMultiselects/ProfileAvailabilitySelect.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormGroupNew from "@/components/form/FormGroupV2.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCitiesMultiselectNew.vue";
import radioOptions from "@/data/filters/radioOptions";
import contractorsCollectionFiltersTemplate from "@/data/filtersTemplates/contractorsCollectionFiltersTemplateV2";
import RadioOption from "@/entities/RadioOption";
import DropdownOption from "@/entities/DropdownOption";
import UserAvailable from "@/entities/filters/UserAvailable";
import ContractorsCollectionFiltersQuery from "@/entities/filters/ContractorsCollectionFiltersQueryV2";
import getMultiselectValues from "@/helpers/multiselect/getMultiselectValues";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";

@Component({
  components: {
    RegionInput,
    InputRangeFilter,
    RadioButtonGroup,
    UiButton,
    FiltersContainer,
    TitlesMultiselect,
    SkillsMultiselect,
    ManagersMultiselect,
    ProjectsMultiselect,
    FormGroupNew,
    FormGroup,
    UiButtonMessage,
    UserCityMultiselect,
    ProfileAvailabilitySelect,
    ProfileCountrySelect,
  },
})
export default class ContractorCollectionFilters extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly hideManagersFilter!: boolean;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly parentInputClass!: string;
  @Prop({ type: Object, required: true })
  readonly filters!: ContractorsCollectionFiltersQuery;

  countries: DropdownOption[] = [];
  states: object = {};
  cities: DropdownOption[] = [];
  titles: DropdownOption[] = [];
  skillsIds: number[] = [];
  projectsIds: string[] = [];
  managersIds: string[] = [];
  name: object = {};
  minRate: string = "";
  maxRate: string = "";
  yes: boolean = true;
  failed: boolean = false;

  available: UserAvailable = contractorsCollectionFiltersTemplate.available;

  radioOptions: RadioOption[] = radioOptions;

  get countriesNames(): string[] {
    return this.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return Array.isArray(this.states) ? this.states.map((state: any) => state.name) : [];
  }

  handleClearName(): void {
    this.name = {};
    this.emitFiltersChanged();
  }

  handleClearRegion(): void {
    this.states = {};
    this.emitFiltersChanged();
  }

  handleSelectionName(selectedItem: any) {
    this.name = selectedItem;
    this.emitFiltersChanged();
  }

  handleSelectionRegion(selectedItem: any) {
    this.states = selectedItem;
    this.emitFiltersChanged();
  }

  get citiesNames(): string[] {
    return this.cities.map((city) => city.name);
  }

  get titlesNames(): string[] {
    return this.titles.map((title) => title.name);
  }

  emitFiltersChanged() {
    this.$emit("filtersChanged", {
      countries: this.countriesNames,
      states: this.states,
      cities: this.citiesNames,
      titles: this.titlesNames,
      skills: this.skillsIds,
      managers: this.managersIds,
      projects: this.projectsIds,
      name: this.name,
      available: this.available,
      minRate: this.minRate,
      maxRate: this.maxRate,
    });
  }

  get propToWatch(): string {
    return JSON.stringify([
      this.name,
      this.available,
      this.minRate,
      this.maxRate,
      this.countriesNames,
      this.states,
      this.citiesNames,
      this.titlesNames,
      this.skillsIds,
      this.managersIds,
      this.projectsIds,
    ]);
  }

  @Watch("filters", { immediate: true })
  updateFiltersValues(): void {
    this.countries = getMultiselectValues(this.filters.countries);
    this.states = this.filters.states;
    this.cities = getMultiselectValues(this.filters.cities);
    this.titles = getMultiselectValues(this.filters.titles);
    this.skillsIds = this.filters.skills;
    this.projectsIds = this.filters.projects;
    this.managersIds = this.filters.managers;
    this.name = this.filters.name;
    this.available = this.filters.available;
    this.minRate = this.filters.minRate;
    this.maxRate = this.filters.maxRate;
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    this.$emit("filtersChanged", {
      countries: this.countriesNames,
      states: this.states,
      cities: this.citiesNames,
      titles: this.titlesNames,
      skills: this.skillsIds,
      managers: this.managersIds,
      projects: this.projectsIds,
      name: this.name,
      available: this.available,
      minRate: this.minRate,
      maxRate: this.maxRate,
    });
  }

  handleReset(): void {
    this.$emit("resetFilters");
  }
}
